var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-modal',{attrs:{"title":_vm.title,"visible":_vm.isVisible,"destroyOnClose":true,"maskClosable":false,"width":"90%","footer":null},on:{"ok":_vm.handleOk,"cancel":_vm.handleCancel}},[_c('customer',{attrs:{"isChild":true},on:{"selectClick":_vm.selectClick}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-924bf10c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modelDialog/customerDialog.vue
// module id = null
// module chunks = 